import $ from 'jquery'
import '../components/daterange'

export default {
  init() {
    $('select[name="project"]').on('input', () => {
      $('.filter-form').submit();
    })
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/espace-adherent-agenda.js